import React, { useContext, useRef, useState } from 'react';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Main, Body } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getProfile, useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import LoadingAnimation from '../../components/LoadingAnimation';
import TimerFunction from './TimerFunction';
import { getCollegeDetailsee } from '../Admission/RemoveAction';
import Admitcardcustom from './Admitcardcustom';
import CoverPage from '../Form/CoverPage';
import ApplicationPrint from '../Form/ApplicationPrint';
import { useQuery } from 'react-query';
import { getQuotaTypes } from '../Form/Component';
import { getCollegeDetails } from '../Form/Register';

function Printercustom({ userId, isStudent, keyData, startDateTimer, stateData, setStateData, onClose, refectData, whoAdmin, parentOnClose, toast }) {
	const { collegeId } = useContext(FirebaseContext);
	const { data: userDetail, isLoading: profileLoading } = useProfileData(userId, !isStudent);
	const [loading, setLoading] = useState(false);
	const [acknowledged, setAcknowledged] = useState(false);
	const [values, setValues] = useState({});
	const { data: collegeData } = useQuery([`collegeData`, collegeId], getCollegeDetailsee);
	const { data: dasaa } = useQuery([`profileDdddata`, collegeId, userDetail?._id], getProfile);
	const { data: classes } = useQuery([`collegeDataddd`, collegeId, '2024-2028'], getCollegeDetails);


	const componentRef = useRef();
	const componentRef2 = useRef();
	const componentRef3 = useRef();

	return (
		<Main title='Confirm Verification' width='90%' height='100%' onClick={onClose}>
			<Body>
			
				<Button type='print' tableRef={componentRef2.current}>
					Print Application
				</Button>
				<Button type='print' tableRef={componentRef3.current}>
					Print Cover Page
				</Button>
        			<>
				<Admitcardcustom userId={userId} collegeData={collegeData} componentRef2={componentRef2} classes={classes} type={dasaa?.dsc_a === 'CLASS-195C8894984F-4A61-81D6-52D3093A13AF' ? 'MCA' : dasaa?.batchName === '2024-2026' ? 'PG' : 'UG'} values={dasaa} getQuotaTypes={getQuotaTypes} />
				<CoverPage collegeData={collegeData} componentRef2={componentRef3} classes={classes} type={dasaa?.dsc_a === 'CLASS-195C8894984F-4A61-81D6-52D3093A13AF' ? 'MCA' : dasaa?.batchName === '2024-2026' ? 'PG' : 'UG'} values={dasaa} getQuotaTypes={getQuotaTypes} />
			</>
			</Body>


		</Main>
	);
}

export default Printercustom;
